export type PresentationMode = "novice" | "expert";

export interface PresentationModeOption {
  value: PresentationMode;
  label: string;
  description: string;
}

export const DEFAULT_PRESENTATION_MODE: PresentationMode = "novice";

export const PRESENTATION_MODE_OPTIONS: PresentationModeOption[] = [
  {
    value: "novice",
    label: "Novice",
    description: "Friendlier summaries with technical details tucked away.",
  },
  {
    value: "expert",
    label: "Expert",
    description: "Full operational detail for diagnosis and support.",
  },
];

export const isPresentationMode = (value: unknown): value is PresentationMode =>
  value === "novice" || value === "expert";

export const normalizePresentationMode = (value: unknown): PresentationMode =>
  isPresentationMode(value) ? value : DEFAULT_PRESENTATION_MODE;

export const isNoviceMode = (value: unknown): boolean =>
  normalizePresentationMode(value) === "novice";

export const isExpertMode = (value: unknown): boolean =>
  normalizePresentationMode(value) === "expert";
